import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes'
import { Auth } from 'aws-amplify'

const isAuthenticated = async (): Promise<boolean> => {
  try {
    const user = await Auth.currentAuthenticatedUser()
    console.log('User is signed in:', user)
    return true
  } catch {
    console.log('User is not signed in')
    return false
  }
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

router.beforeEach(async (to, from, next) => {
  const publicRouteNames = new Set(['login', 'reset', 'temporary-password'])
  const requiresAuth = !publicRouteNames.has(String(to.name || ''))

  if (requiresAuth) {
    const hasSession = await isAuthenticated()

    if (hasSession) {
      return next()
    } else {
      return next('/login')
    }
  } else {
    return next()
  }
})

export default router
